import { useEffect, useState } from 'react';
import { CardBuilder, ImageUrlSelector, type Card } from '../common';
import { getTypeOfContentUnderUrl } from '../../api';
import type { ImageCardData } from './UseUploadAndPresetCards';

export type UseCustomUploadCardType = {
    onChange: (url: string | undefined) => void;
    fileUrl: string | undefined;
    createImageCard: (imageCardData: ImageCardData) => Promise<Card>;
};

export function useCustomUploadCard({ onChange, fileUrl, createImageCard }: UseCustomUploadCardType) {
    const [customUploadCard, setCustomUploadCard] = useState<Card>();

    useEffect(() => {
        const createCustomUploadCard = async (): Promise<Card> => {
            if (!fileUrl) {
                return CardBuilder.ofType('childComponent')
                    .withTitle('Custom Upload or CimDoc URL')
                    .withChildComponent(() => (
                        <div
                            style={{
                                padding: '12px',
                                minHeight: '320px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px',
                            }}
                        >
                            <div>
                                <ImageUrlSelector
                                    url={fileUrl || ''}
                                    setIsImageLoading={() => {}}
                                    onChange={onChange}
                                    selectorOptions={[]}
                                />
                            </div>
                        </div>
                    ))
                    .build();
            }

            const type = await getTypeOfContentUnderUrl(fileUrl);
            return createImageCard({ fileUrl: fileUrl, title: 'Custom upload', type });
        };

        (async () => {
            setCustomUploadCard(await createCustomUploadCard());
        })();
    }, [fileUrl, onChange, setCustomUploadCard, createImageCard]);

    return customUploadCard;
}
